import React from 'react'

// import { Button } from 'antd'
// import { DeleteOutlined } from '@ant-design/icons'

// import { compareStr, timeFormatDefault } from 'utils'

interface SignatureRecord {
  signatureId: string
  title: string
  default: boolean
}

interface ColumnConfig {
  title: string
  align: 'left' | 'center' | 'right'
  dataIndex: string[]
  render: (text: any, record: SignatureRecord) => React.ReactElement
  width?: number
  sortOrder?: string
}

interface TableInfo {
  useMobileMode: boolean
  defaultVariables: {
    pageSize: number
    pageNum: number
  }
  getColumns: () => ColumnConfig[]
  getKeyFunc: (item: SignatureRecord) => string
}

const info: TableInfo = {
  useMobileMode: false,
  defaultVariables: {
    pageSize: 10,
    pageNum: 1,
  },
  // onRow: (record, rowIndex, reactObj) => {
  //   return {
  //     onClick: () => {
  //       console.log(' - click report ', record, rowIndex)
  //       const { navigate } = reactObj.props
  //       navigate(`/appconfig/detail/${record.node.id}`)
  //     }, // click row
  //     // onDoubleClick: () => {}, // double click row
  //     // onContextMenu: () => {}, // right button click row
  //     // onMouseEnter: () => {}, // mouse enter row
  //     // onMouseLeave: () => {}, // mouse leave row
  //   }
  // },
  // getColumns: ({ t, styles }, reactObj) => {
  getColumns: () => {
    const columns: ColumnConfig[] = [
      {
        title: 'icon',
        align: 'center',
        dataIndex: ['signatureId'],
        render: (text, record) => {
          return <span>{record.signatureId}</span>
        },
        width: 100,
      },
      {
        title: 'title',
        align: 'left',
        // sortOrder: 'descend',
        dataIndex: ['title'],
        render: (text, record) => {
          return <span>{record.title}</span>
        },
      },
      {
        title: 'etc',
        align: 'center',
        // sortOrder: 'descend',
        dataIndex: ['default'],
        render: (text, record) => {
          return <span>{record.default.toString()}</span>
        },
        width: 100,
      },
    ]

    return columns
  },
  getKeyFunc: function getKeyFunc(item: SignatureRecord): string {
    return item.signatureId
  },
}

export default info
